export default {
  no_mobile_app: 'Nessuna app mobile configurata',
  mobile_app_not_live: 'App mobile non attiva',
};
